<!-- @format -->

<div class="flex justify-between items-center gap-3">
  <div class="text">{{ data.text }}</div>
  <div class="flex -mr-2 -my-3">
    <button *ngIf="data.action" (click)="snackBarRef.dismissWithAction()" class="h-10 rounded hover:bg-hover px-3">{{ data.action }}</button>
    <button (click)="snackBarRef.dismiss()" class="w-10 h-10 rounded-full hover:bg-hover">✕</button>
  </div>
</div>
